import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { updateOrderdata } from '../../store/slices/wholesaleOrderSlice';
import { TextField, Stack, Box,Select,MenuItem,InputLabel,FormControl,RadioGroup,Radio,FormControlLabel,FormLabel } from '@mui/material';
import { constants } from '../../constants';
export default function CustomerForm() {
  const dispatch = useDispatch();
  const orderData = useSelector((state) => state.order);


  const { customername, customeremail, customerphonenumber } = useSelector(
    (state) => state.order
  );

  const [errors, setErrors] = useState({
    customername: false,
    customerphonenumber: false
  });

  const [touched, setTouched] = useState({
    customername: false,
    customerphonenumber: false
  });

  const handleChange = (field) => (e) => {
    const value = e.target.value;
    dispatch(updateOrderdata({ field, value }));
    if (touched[field]) validateField(field, value);
  };

  const handleBlur = (field, value) => () => {
    setTouched((prev) => ({ ...prev, [field]: true }));
    validateField(field, value);
  };

  const validateField = (field, value) => {
    setErrors((prev) => ({
      ...prev,
      [field]: value.trim() === '',
    }));
  };

  return (
    <Box mt={2}>
      <Stack
        direction={{ xs: 'column', md: 'row' }} // column on mobile, row on desktop
        spacing={2}
      >
        <TextField
          label="Customer Name"
          value={customername}
          onChange={handleChange('customername')}
          onBlur={handleBlur('customername', customername)}
          error={errors.customername}
          helperText={errors.customername ? 'Customer name is required' : ''}
          size='small'
          required
        />
        <TextField
          label="Customer Email"
          value={customeremail}
          onChange={handleChange('customeremail')}
          type="email"
             size='small'
        />
        <TextField
          label="Customer Phone Number"
          value={customerphonenumber}
          onChange={handleChange('customerphonenumber')}
          onBlur={handleBlur('customerphonenumber', customerphonenumber)}
          error={errors.customerphonenumber}
          helperText={
            errors.customerphonenumber
              ? 'Customer phone number is required'
              : ''
          }
          size='small'
        />

      </Stack>
      <Stack
        direction={{ xs: 'column', md: 'row' }} // column on mobile, row on desktop
        sx={{ mt: 2 }}
        spacing={2}
      >
      <FormControl  variant="outlined" size="small"  sx={{ minWidth: 150 }}>
          <InputLabel id="paymentmode-label">Payment Mode</InputLabel>
        <Select
      labelId="paymentmode-label"
      id="paymentmode"
      value={orderData.paymentmode || ''}
    size='small'
      onChange={(e) =>
        dispatch(
          updateOrderdata({
            field: 'paymentmode',
            value: e.target.value
          })
        )
      }
      label="Payment Mode" // Important for proper floating label
    >
      <MenuItem value={constants.PAYMENT_MODE.CASH}>Cash</MenuItem>
      <MenuItem value={constants.PAYMENT_MODE.CARD}>Card</MenuItem>
      <MenuItem value={constants.PAYMENT_MODE.BANKTRANSFER}>Bank Transfer</MenuItem>
      <MenuItem value={constants.PAYMENT_MODE.PAYPAL}>Paypal</MenuItem>
    </Select>
    </FormControl>


    <FormControl  variant="outlined" size="small"   sx={{
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: 2, // space between label and radios
    minWidth: 150
  }}>
      <FormLabel id='paymentstatus-label'>Payment Status : </FormLabel>
      <RadioGroup
        row
        name="paymentstatus"
        labelId="paymentstatus-label"
        value={orderData.paymentstatus}
        onChange={(e) =>
          dispatch(
            updateOrderdata({
              field: 'paymentstatus',
              value: e.target.value
            })
          )
        }
      >
        <FormControlLabel value={constants.PAYMENT_STATUS.PENDING} control={<Radio />} label="Pending" />
        <FormControlLabel value={constants.PAYMENT_STATUS.PAID} control={<Radio />} label="Paid" />
      </RadioGroup>
    </FormControl>

      </Stack>



    </Box>
  );
}
